<template>
    <b-card :title="title">
        <b-card-body>
            <b-card-header>
                <b-row>
                    <b-col>
                        <b-form-input
                            type="search"
                            placeholder="Search Locations..."
                            v-model="query"
                            @input="updateQuery"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="8">
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table
                responsive
                :fields="locationFields"
                striped
                hover
                :items="locations"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"                       
                        :to="`${$route.path}/${row.item.id}`"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="locationTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'ListItems',
    props: ['type', 'title'],

    data() {
        return {
            locationFields: [
                'name',
                'address1',
                'city',
                {
                    key: 'is_warehouse',
                    label: 'Is Warehouse',
                    formatter: value => {
                        return value ? 'Yes' : 'No'
                    },
                },
                {
                    key: 'id',
                    label: '',
                },
            ],
            query: '',
            page: 1,
        }
    },

    methods: {
        doSearch() {
            const { query, page, filters } = this
            this.$store.dispatch('locations/fetchLocations', {
                query,
                page,
                filters,
            })
        },
        updateQuery: _.debounce(function(query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function(page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
    },
    watch: {
        'pagination.page': function(newPage) {
            this.changePage(newPage)
        },
    },
    mounted() {
        console.log('locations', this.locations)
        this.doSearch()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        locations() {
            return this.$store.state.locations.locations
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.locations.pagination || {}
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
